import TurfBuffer from '@turf/buffer';
import {polygon, featureCollection} from '@turf/helpers';
import circle from '@turf/circle';
import centroid from '@turf/centroid';


class LayerDrawing {
	

	
	constructor(du, scenario, tc) {
		
		this.scenario = scenario;
		this.map = du.map;
		this.du = du;
		this.tc = tc;
		//this.placeBoundaries();
		
	}
	
	
	
//	placeBoundaries(){
//		
//		var self = this;
//		var b = structuredClone(this.scenario.boundary);	
//		
//
//
//		if(this.map.getLayer(LayerDrawing.layerId)){
//			this.map.removeLayer(LayerDrawing.layerId);
//			this.map.removeSource(LayerDrawing.sourceId);
//		}
//
//				
//		if(!this.map.getSource(LayerDrawing.sourceId))
//			this.map.addSource(LayerDrawing.sourceId, {
//				'type': 'geojson',
//				'data': b.geometry
//			});
//
//		// Add a new layer to visualize the polygon.
//		if(!this.map.getLayer(LayerDrawing.layerId)){
//			this.map.addLayer({
//				'id': LayerDrawing.layerId,
//				'type': 'line',
//				'source': LayerDrawing.sourceId, // reference the data source
//				'layout': {
//					'visibility' : this.map.layerStatus['boundary'] ? 'visible' : 'none'
//				},
//				'paint': {
//					'line-color': LayerDrawing.defaultColor,
//					'line-opacity': 1,
//					'line-width' : LayerDrawing.defaultWidth
//				},
//				'filter': ['==', '$type', 'Polygon']
//			});
//
//		}
//	}
	json(){
		
		var self = this;
		var b = structuredClone(this.scenario.drawings);	
		


		const l = {
				source : {
					'id': LayerDrawing.sourceId,
					'type'	: 'geojson',
					'data'	: this.convert(),
					'promoteId' : 'drawing_id'
				}
			};

		l.layer = [
	
				{
					'id': LayerDrawing.layerId,
					'type': 'fill',
					'source': LayerDrawing.sourceId, // reference the data source
					'paint': {
						'fill-color': ["get", "color"],
						'fill-opacity': ['case',
							['boolean', ['get', 'invisible'], false],0,
							['boolean', ['feature-state', 'invisible'], false],0,
							['boolean', ['feature-state', 'hover'], false],.7,
							['boolean', ['feature-state', 'selected'], false],.3,
							["get", "opacity"]
						]
					},
					'filter': ['==', '$type', 'Polygon']
				},
				/*{
					'id': LayerDrawing.layerOutlineId,
					'type': 'line',
					'source': LayerDrawing.sourceId, // reference the data source
					'paint': {
						'line-color': ["get", "color"],
						'line-opacity': ['case',
							['boolean', ['feature-state', 'invisible'], false],0,
							['boolean', ['feature-state', 'hover'], false],1,
							['boolean', ['feature-state', 'selected'], false],1,
								.7
						],
						'line-width': 3
					},
					'filter': ['==', '$type', 'Polygon']
				},
				{
					'id': LayerDrawing.layerPointsMarkerId,
					'type': 'symbol',
					'source': LayerDrawing.sourceId,
					"paint": {
						'text-color': "#93370D", //Color of your choice
						'text-halo-width': 1,
						'text-halo-color': "#ffffff",
						'icon-opacity':['case',
							['boolean', ['feature-state', 'invisible'], false],0,
							['boolean', ['feature-state', 'hover'], false],1,
							['boolean', ['feature-state', 'selected'], false],1,
							0
						]
					}, // reference the data source
					'layout': {
						'icon-image':'ex_point_marker',
						'icon-anchor' : 'bottom',
						'icon-allow-overlap' : true,
						'text-field': ['case',
							['has', 'hidden'],'',
							['get', 'name']
						], //This will get "t" property from your geojson
						'text-rotation-alignment': "auto",
						'text-allow-overlap': true,
						'text-anchor': "top",
						'text-size': 14,
					},
					'filter': [
						'all',
						['==', ['geometry-type'], 'Point'],
					]
				},
				{
					'id': LayerDrawing.layerPointsTextId,
					'type': 'symbol',
					'source': LayerDrawing.sourceId,
					"paint": {
						'text-color': "#93370D", //Color of your choice
						'text-halo-width': 1,
						'text-halo-color': "#ffffff",
						'text-opacity':['case',
							['boolean', ['feature-state', 'invisible'], false],0,
							['boolean', ['feature-state', 'hover'], false],1,
							['boolean', ['feature-state', 'selected'], false],1,
							0
						]
					}, // reference the data source
					'layout': {
						'icon-anchor' : 'bottom',
						'icon-allow-overlap' : true,
						'text-field': ['case',
							['has', 'hidden'],'',
							['get', 'name']
						], //This will get "t" property from your geojson
						'text-rotation-alignment': "auto",
						'text-allow-overlap': true,
						'text-anchor': "top",
						'text-size': 14,
					},
					'filter': [
						'all',
						['==', ['geometry-type'], 'Point'],
					]
				}*/
				
			
		];

		return l;
	}
	
	convert(){
		
		const polygons = [];
		const geom = structuredClone(this.scenario.drawings ?? []);
		
		
		var auxLayers = [];
		
		geom.forEach((p, i) => {
			
			
			if(['MultiLineString', 'LineString'].includes(p.geometry.type)){
				
				
				const center = p.geometry.type == 'MultiLineString' ? {lng: p.geometry.coordinates[0][0][0], lat: p.geometry.coordinates[0][0][1] } : {lng: p.geometry.coordinates[0][0], lat: p.geometry.coordinates[0][1] };
				const width = LayerDrawing.lineWidthInMeters(p.properties.thickness, p.properties.zoom, center);
				
				const newfeature = TurfBuffer(p, width, { units: 'meters' });
				
				newfeature.properties = structuredClone(p.properties);
				newfeature.properties.polygon_id = p.properties.drawing_id;
				
				auxLayers.push(newfeature);
			}
			
		});


		geom.push(...auxLayers);
		

		return featureCollection(geom);
	}
	

}

LayerDrawing.layerId				= 'drawing_layer';
LayerDrawing.layerOutlineId			= 'drawing_layer_outline';
LayerDrawing.layerPointsId			= 'drawing_points_layer';
LayerDrawing.layerPointsMarkerId	= 'drawing_points_marker_layer';
LayerDrawing.layerPointsTextId		= 'drawing_layer_labels'
LayerDrawing.sourceId				= 'drawing_source';
LayerDrawing.defaultThickness		= 6;
LayerDrawing.defaultOpacity			= 1;
LayerDrawing.defaultColor			= "#b237cf";
LayerDrawing.layers					= [
	{id: LayerDrawing.layerId },
];

LayerDrawing.lineWidthInMeters = (lineWidthPx, zoom, center) => {

	const latitude = center.lat;

	const metersPerPixel =
		(156543.03392 * Math.cos(latitude * Math.PI / 180)) /
		Math.pow(2, zoom);

	return lineWidthPx * metersPerPixel;
}

LayerDrawing.getCenter = (l) => {

	return l.geometry.type == 'MultiLineString' ? {lng: l.geometry.coordinates[0][0][0], lat: l.geometry.coordinates[0][0][1] } : {lng: l.geometry.coordinates[0][0], lat: l.geometry.coordinates[0][1] }
}

export default LayerDrawing;